/* ============
 * UnderlyingAssetType Module
 * ============
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  state: {
    paymentTypes: [],
  },
  actions,
  getters,
  mutations
};
